"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _useMedia = require("../../../hooks/use-media");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  img {\n    max-width: 100%;\n    display: block;\n    margin: 0 auto;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TextImageStyled = (0, _uiKit.styled)('div')(_templateObject());

var deviceImage = function deviceImage(_ref) {
  var images = _ref.images,
      device = _ref.device;
  return images.find(function (_ref2) {
    var visible = _ref2.visible;
    return visible === device;
  });
};

var getAltTextImg = function getAltTextImg(_ref3) {
  var images = _ref3.images;
  return images.find(function (_ref4) {
    var altText = _ref4.altText;
    return !!altText;
  });
};

var TextImage = function TextImage(_ref5) {
  var images = _ref5.images;
  var isMobile = (0, _useMedia.useMedia)("(max-width: 575px)");
  var isTablet = (0, _useMedia.useMedia)("(min-width: 576px) and (max-width: 991px)");
  var isAltText = getAltTextImg({
    images: images
  });
  var all = deviceImage({
    images: images,
    device: 'all'
  });
  var desktop = deviceImage({
    images: images,
    device: 'desktop'
  });
  var tablet = deviceImage({
    images: images,
    device: 'tablet'
  });
  var mobile = deviceImage({
    images: images,
    device: 'mobile'
  });
  var desktopImage = desktop && desktop['image'] || 'https://via.placeholder.com/1920x500?text=empty';
  var tabletImage = tablet && tablet['image'] || desktopImage;
  var mobileImage = mobile && mobile['image'] || tabletImage;
  var imgProps = {
    src: all ? all['image'] : isMobile ? mobileImage : isTablet ? tabletImage : desktopImage
  };
  return /*#__PURE__*/_react.default.createElement(TextImageStyled, null, /*#__PURE__*/_react.default.createElement("img", _objectSpread(_objectSpread({}, imgProps), isAltText && {
    alt: isAltText['altText']
  })));
};

var _default = TextImage;
exports.default = _default;